const isJwt = (token: string) => token.split(".").length === 3

export default isJwt
